export const HOME_SLIDE = {
  title: 0,
  loading: 1,
  intro: 2,
  firstProject: 3,
} as const;

export const projectSlideIndex = (projectIndex: number) => HOME_SLIDE.firstProject + projectIndex;

export const reachSlideIndex = (projectCount: number) => HOME_SLIDE.firstProject + projectCount;
